import ExchangeVersionType from 'owa-service/lib/contract/ExchangeVersionType';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import getItemOperation from 'owa-service/lib/operation/getItemOperation';
import getItemRequest from 'owa-service/lib/factory/getItemRequest';
import itemId from 'owa-service/lib/factory/itemId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';
import { isFeatureEnabled } from 'owa-feature-flags';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function getItem(
    ids: string[],
    itemShape: ItemResponseShape,
    shapeName: string,
    requestServerVersion?: ExchangeVersionType,
    options?: RequestOptions,
    internetMessageId?: string
): Promise<SingleResponseMessage[]> {
    const jsonRequestHeader = getJsonRequestHeader();

    if (requestServerVersion) {
        jsonRequestHeader.RequestServerVersion = requestServerVersion;
    }

    if (isConsumer() && isFeatureEnabled('rp-amp')) {
        const ampPropertyUri = propertyUri({ FieldURI: 'AmpHtmlBody' });
        if (itemShape.AdditionalProperties) {
            itemShape.AdditionalProperties.push(ampPropertyUri);
        } else {
            itemShape.AdditionalProperties = [ampPropertyUri];
        }
    }

    const serviceItemIds = ids.map(id => {
        return itemId({ Id: id });
    });
    return getItemOperation(
        {
            Header: jsonRequestHeader,
            Body: getItemRequest({
                ItemShape: itemShape,
                ItemIds: serviceItemIds,
                ShapeName: shapeName,
                InternetMessageId: internetMessageId,
            }),
        },
        options
    ).then(response => {
        return response.Body.ResponseMessages.Items;
    });
}
